import { useEffect, useState } from "react";
import { FinalizarCompraSaldo } from "./FinalizarCompraSaldo";
import { FinalizarCompraPix } from "./FinalizarCompraPix";
import AcessoService, { PresenteadoDto } from "@/services/AcessoService";
import { FinalizarCompraCartaoCredito } from "./FinalizarCompraCartaoCredito";
import CautelaService from "@/services/CautelaService";
import { BuscarCautelasCarrinhoDto } from "@/dtos/Request/RequestBuscarCautelasCarrinho";
import CompraService from "@/services/CompraService";
import { FormasPagamento } from "@/dtos/FormasPagamento";
import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import clsx from "clsx";
import { Coins, CreditCard } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AppService from "@/services/AppService";
import { FinalizarCompraCartaoCreditoForm } from "./FinalizarCompraCartaoCredito.Form";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { toast } from "@/components/ui/use-toast";
import { DadosCompraCartaoCreditoDto } from "@/dtos/Request/RequestDadosCompraCartaoCreditoDto";
import { useCarrinho } from "@/contexts/CarrinhoProvider";
import { Button } from "@/components/ui/button";
import StorageUtils from "@/utils/StorageUtils";
import { labelSingularLower } from "@/utils/copyTituloBilhete";

interface DadosCartaoCredito {
    nome: string,
    numeroCartao: string,
    dataVencimento: string,
    codSeguranca: string,
}



export function FinalizarCompraPage() {
    const [formaPagamento, setFormaPagamento] = useState<FormasPagamento>(FormasPagamento.Pix);
    const [saldoDisponivel, setSaldoDisponivel] = useState(0);
    const [dadosResumo, setDadosResumo] = useState<BuscarCautelasCarrinhoDto>({} as BuscarCautelasCarrinhoDto)
    const [loading, setLoading] = useState(true);
    const [podeRealizarPagamentoCartaoCredito, setPodeRealizarPagamentoCartaoCredito] = useState(true);
    const navigate = useNavigate();
    const [searchParams, _setSearchParams] = useSearchParams();
    const { atualizarQuantidadeCarrinho } = useCarrinho();
    const [token, setToken] = useState('');
    const [presenteados, setPresenteados] = useState<PresenteadoDto[]>([]);


    useEffect(() => {
        if (location.pathname.toLowerCase().indexOf('/finalizarcompraapp') >= 0) {
            const match = (window.location.href).match(/(?:\?|&)token=([^&]+)/);
            const searchParamToken = match ? match[1] : null;

            if (searchParamToken !== null) {
                setToken(searchParamToken);
            } else {
                navigate('/')
            }
        } else {
            initialLoad()
        }
    }, [])

    useEffect(() => {
        if (token) {
            initialLoadApp()
        }
    }, [token])

    async function handlePresenteados(action: 'remove' | 'load', presenteado?: PresenteadoDto) {
        switch (action) {
            case 'remove':

                if (token) {
                    await AppService.removerPresenteado(presenteado!.IdUsuario, token);
                } else {
                    await AcessoService.removerPresenteado(presenteado!.IdUsuario);
                }

                await handlePresenteados('load');
                break;
            case 'load':
                if (token) {
                    const { Data: result } = await AppService.buscarPresenteados(token);
                    setPresenteados(result);
                } else {
                    const { Data: result } = await AcessoService.buscarPresenteados();
                    setPresenteados(result);
                }

                break;
        }
    }

    async function initialLoadApp() {
        const { Data: result } = await AppService.buscarSaldoCreditoApp(token);
        setSaldoDisponivel(result);

        const { Data: result2 } = await AppService.buscarCautelasCarrinhoApp(token);
        setDadosResumo(result2);

        const { Data: result3 } = await AppService.VerificarCartaoCreditoHabilitadoApp(token);
        setPodeRealizarPagamentoCartaoCredito(result3)

        const { Data: result4 } = await AppService.buscarPresenteados(token);
        setPresenteados(result4);

        if (result >= result2.ValorTotal) {
            setFormaPagamento(FormasPagamento.Saldo);
        }

        setLoading(false);
    }

    async function initialLoad() {
        const { Data: result } = await AcessoService.buscarSaldoCredito();
        setSaldoDisponivel(result);

        const { Data: result2 } = await CautelaService.buscarCautelasCarrinho();
        setDadosResumo(result2);

        const { Data: result3 } = await CompraService.VerificarCartaoCreditoHabilitado();
        setPodeRealizarPagamentoCartaoCredito(result3);

        const { Data: result4 } = await AcessoService.buscarPresenteados();
        setPresenteados(result4);

        if (result >= result2.ValorTotal) {
            setFormaPagamento(FormasPagamento.Saldo);
        }

        setLoading(false);
    }

    function handleSelecionarFormaPagamento(value: FormasPagamento) {
        setFormaPagamento(value)
    }

    const formikFormFinalizarCompraCartaoCredito = useFormik<DadosCartaoCredito>({
        initialValues: {
            nome: '',
            numeroCartao: '',
            dataVencimento: '',
            codSeguranca: '',
        },
        validationSchema: Yup.object({
            nome: Yup.string()
                .min(3, 'Deve possuir ao menos 5 caracteres')
                .test('Validar nome', 'Insira nome que consta no cartão de crédito', valueToValidate => {
                    if (!valueToValidate) {
                        return false;
                    }

                    if (valueToValidate.indexOf(' ') === -1 || valueToValidate.indexOf(' ') === (valueToValidate.length - 1)) {
                        return false;
                    }

                    return true;
                }),
            numeroCartao: Yup.string()
                .required('Obrigatório')
                .test('Validar Cartão de Crédito', 'Cartão de Crédito Inválido', valuepToValidate => {
                    if (valuepToValidate.replace(/_/g, '').replace(/\./g, '').length !== 16) {
                        return false;
                    }

                    return true;
                }),
            dataVencimento: Yup.string()
                .required('Obrigatório')
                .test('Validar data vencimento', 'Data Inválida', valueToValidate => {
                    if (valueToValidate.replace(/_/g, '').replace(/\//g, '').length !== 4) {
                        return false;
                    }

                    const mes = parseInt(valueToValidate.split('/')[0]);

                    if (mes === 0 || mes > 12) {
                        return false;
                    }

                    const ano = parseInt('20' + valueToValidate.split('/')[1]);

                    const dataAtual = new Date();

                    if (dataAtual.getFullYear() === ano && mes < (dataAtual.getMonth() + 1)) {
                        return false;
                    }

                    if (ano < dataAtual.getFullYear()) {
                        return false;
                    }

                    return true;
                }),
            codSeguranca: Yup.string()
                .required('Obrigatório')
                .test('Validar Cod. Segurança', 'Cod. Inválido', valuepToValidate => {
                    if (valuepToValidate.replace(/_/g, '').length !== 3) {
                        return false;
                    }

                    return true;
                }),
        }),
        onSubmit: async (values) => {
            try {
                const mes = values.dataVencimento.split('/')[0]
                const ano = values.dataVencimento.split('/')[1]

                const dispositivo = localStorage.getItem('Dispositivo');
                if (dispositivo == null) {
                    const dispositivoCodigo = Math.random().toString(36).substring(2);
                    localStorage.setItem('Dispositivo', dispositivoCodigo);
                }

                let idPresenteado: number | undefined = undefined;
                const getIdPessoaPresenteada = searchParams.get('idPessoaPresenteada');

                if (getIdPessoaPresenteada) {
                    idPresenteado = Number(getIdPessoaPresenteada);
                }

                let idVendedor = StorageUtils.getIdVendedor();

                const dadosCartao: DadosCompraCartaoCreditoDto = {
                    VencimentoAno: ano,
                    VencimentoMes: mes,
                    VencimentoCartao: values.dataVencimento,
                    TitularCartao: values.nome,
                    NumeroCartao: values.numeroCartao.replace(/_/g, '').replace(/\./g, ''),
                    VerificadorCartao: values.codSeguranca,
                    Origem: 'Web',
                    Cautelas: dadosResumo.Cautelas.map(c => c.IdCautela),
                    FormaPagamento: formaPagamento,
                    IdentificadorDispositivo: await StorageUtils.getDispositivo(),
                    Data: '',
                    IdPresenteado: idPresenteado,
                    IdVendedor: idVendedor
                };

                if (token) {
                    await AppService.FinalizarCompraCartaoCreditoApp(dadosCartao, token);
                    toast({
                        variant: 'success',
                        description: `Sua compra está em análise pelo cartão. A confirmação da compra será enviada para o seu e-mail, Feche o navegador e acesse o histórico de compras em seu aplicativo para visualizar seu ${labelSingularLower()}`,
                        title: 'Compra com saldo de crédito',
                        duration: 6000
                    })

                    StorageUtils.removeIdVendedor();
                } else {
                    await CompraService.FinalizarCompraCartaoCredito(dadosCartao);

                    toast({
                        variant: 'success',
                        description: 'Sua compra está em análise pelo cartão. A confirmação da compra será enviada para o seu e-mail',
                        title: 'Compra em avaliação',
                        duration: 10000
                    })


                    StorageUtils.removeIdVendedor();

                    atualizarQuantidadeCarrinho();
                    navigate('/Comprar-Titulos');
                }
            } catch (error: any) {
                toast({
                    variant: 'destructive',
                    description: error,
                    duration: 4000
                });
            }
        }
    });

    return loading ? (
        <div className="ms-4 mb-20 px-3 lg:px-0">
            <Skeleton className="h-10 w-44" />
            <Skeleton className="h-10 w-96 mt-1" />
            <Skeleton className="h-10 w-56 mt-4" />

            <div className="flex mt-2">
                <Skeleton className="h-14 w-2/4" />
                <Skeleton className="h-72 w-2/4 ms-4" />
            </div>

            <div className="flex justify-end">
                <Skeleton className="h-10 w-64 mt-4" />
            </div>
        </div>
    ) : (
        <>
            <div className="ms-4 mb-10 px-3 lg:px-0">
                <h1 className="text-primary font-bold text-2xl">Finalizar Compra</h1>
                <p>
                    Para concluir a compra, selecione uma forma de pagamento
                </p>

                <div className="flex flex-col md:flex-row gap-5 mt-6">
                    <div className="flex flex-col md:w-7/12">
                        <div className="flex flex-rol justify-start gap-4 mb-10">
                            <Card onClick={() => {
                                handleSelecionarFormaPagamento(FormasPagamento.Pix)
                            }} className={
                                clsx('w-36 h-36 cursor-pointer hover:bg-buttondefault/80', {
                                    'bg-buttondefault': formaPagamento?.toString() === FormasPagamento.Pix.toString()
                                })
                            }>
                                <CardHeader className="flex text-center text-buttondefault-foreground">
                                    <CardTitle>Pix</CardTitle>
                                </CardHeader>
                                <CardContent className="flex justify-center text-buttondefault-foreground">
                                    <Coins />
                                </CardContent>
                            </Card>

                            {
                                podeRealizarPagamentoCartaoCredito && (
                                    <Card onClick={() => {
                                        handleSelecionarFormaPagamento(FormasPagamento.CartaoCredito)
                                    }} className={
                                        clsx('w-52 h-36 cursor-pointer hover:bg-buttondefault/80', {
                                            'bg-buttondefault': formaPagamento?.toString() === FormasPagamento.CartaoCredito.toString()
                                        })
                                    }>
                                        <CardHeader className="flex text-center text-buttondefault-foreground">
                                            <CardTitle>Cartão de Crédito</CardTitle>
                                        </CardHeader>
                                        <CardContent className="flex justify-center text-buttondefault-foreground">
                                            <CreditCard />
                                        </CardContent>
                                    </Card>
                                )
                            }

                            {
                                saldoDisponivel > 0 && (
                                    <Card onClick={() => {
                                        handleSelecionarFormaPagamento(FormasPagamento.Saldo)
                                    }} className={
                                        clsx('w-52 h-36 cursor-pointer hover:bg-buttondefault/80', {
                                            'bg-buttondefault': formaPagamento?.toString() === FormasPagamento.Saldo.toString()
                                        })
                                    }>
                                        <CardHeader className="flex text-center text-buttondefault-foreground">
                                            <CardTitle>Saldo de Crédito</CardTitle>
                                        </CardHeader>
                                        <CardContent className="flex justify-center text-buttondefault-foreground">
                                            <Coins />
                                        </CardContent>
                                    </Card>
                                )
                            }

                            {
                                podeRealizarPagamentoCartaoCredito && (
                                    <Card onClick={() => {
                                        handleSelecionarFormaPagamento(FormasPagamento.AuxilioEmergencial)
                                    }} className={
                                        clsx('w-40 h-36 cursor-pointer hover:bg-buttondefault/80', {
                                            'bg-buttondefault': formaPagamento?.toString() === FormasPagamento.AuxilioEmergencial.toString()
                                        })
                                    }>
                                        <CardHeader className="flex text-center text-buttondefault-foreground">
                                            <CardTitle>Auxilio Emergencial Caixa</CardTitle>
                                        </CardHeader>
                                        <CardContent className="flex justify-center text-buttondefault-foreground">
                                            <CreditCard />
                                        </CardContent>
                                    </Card>
                                )
                            }
                        </div>

                        {
                            (formaPagamento === FormasPagamento.CartaoCredito || formaPagamento === FormasPagamento.AuxilioEmergencial) &&
                            <FinalizarCompraCartaoCreditoForm
                                formik={formikFormFinalizarCompraCartaoCredito}
                                dadosResumo={dadosResumo}
                                formaPagamento={formaPagamento} />
                        }

                        {
                            formaPagamento === FormasPagamento.Saldo && (
                                <div className="flex flex-col md:flex-row justify-between">
                                    <div className="md:w-6/12">
                                        <h2 className="text-xl text-primary-foreground mb-5">
                                            Saldo disponível: {saldoDisponivel.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                        </h2>

                                        {
                                            (saldoDisponivel < dadosResumo.ValorTotal) && (
                                                <div className="flex mt-2">
                                                    <Button className="w-full sm:w-56">Comprar Créditos</Button>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            )
                        }
                    </div>


                    {
                        (formaPagamento === FormasPagamento.CartaoCredito || formaPagamento === FormasPagamento.AuxilioEmergencial) &&
                        <FinalizarCompraCartaoCredito
                            handlePresenteados={handlePresenteados}
                            presenteados={presenteados}
                            dadosResumo={dadosResumo}
                            formik={formikFormFinalizarCompraCartaoCredito}
                        />
                    }

                    {
                        formaPagamento === FormasPagamento.Saldo &&
                        <FinalizarCompraSaldo
                            handlePresenteados={handlePresenteados}
                            presenteados={presenteados}
                            token={token}
                            dadosResumo={dadosResumo}
                            saldoDisponivel={saldoDisponivel}
                        />
                    }

                    {
                        formaPagamento === FormasPagamento.Pix &&
                        <FinalizarCompraPix
                            handlePresenteados={handlePresenteados}
                            presenteados={presenteados}
                            token={token}
                            dadosResumo={dadosResumo}
                        />
                    }
                </div>


            </div>
        </>
    )
}